import * as layout from '../../../components/markLayout.module.css';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
const IrreversibleWarning: React.FC = () => (
    <div
        role="alert"
        style={{
            backgroundColor: 'var(--mark-danger-surface)',
            marginBottom: '1.6rem',
            color: 'var(--mark-danger)'
        }}
        className={layout.notice}
    >
        <P noDefaultMargin strong>
            The name, trigger type, and prospect type cannot be changed after creation. Review these
            choices carefully before creating your drip.
        </P>
    </div>
);
export default IrreversibleWarning;
